import { History } from "history";

import { API, FormDataAPI } from "./base/BaseApi";
import { AttachmentsService } from '../pages/projectDocs/services/AttachmentsService';
import { AuthService } from "../pages/unAuthorized/services/AuthService";
import { BalanceUnitService } from "../pages/projects/services/BalanceUnitService";
import { ContractorsService } from "../pages/projectDocs/services/ContractorsService";
import { DictionariesService } from "./DictionariesService";
import { DocTemplateService } from "../pages/templates/services/DocTemplateService";
import { DocTemplateFolderService } from "../pages/templates/services/DocTemplateFolderService";
import { DocTemplateFolderTypeService } from "../pages/templates/services/DocTemplateFolderTypeService";
import { DocTypeService } from "../pages/templates/services/DocTypeService";
import { GroupService } from "../pages/settings/groups/services/GroupService";
import { GroupTypeService } from "../pages/settings/groups/services/GroupTypeService";
import { PDFAttachmentsService } from '../pages/projectDocs/services/PDFAttachmentsService';
import { PDFAttachmentsJsonService } from '../pages/projectDocs/services/PDFAttachmentsJsonService';
import { PDFNoteService } from "../pages/notes/services/PDFNoteService";
import { PDFNoteCodeService } from "../pages/notes/services/PDFNoteCodeService";
import { ProjectService } from "../pages/projects/services/ProjectService";
import { ProjectDocService } from "../pages/projectDocs/services/ProjectDocService"
import { ProjectDocFolderService } from "../pages/projectDocs/services/ProjectDocFolderService";
import { ProjectDocFolderStatusService } from "../pages/projectDocs/services/ProjectDocFolderStatusService";
import { ProjectDocWorkflowApproverService } from "../pages/workflows/services/ProjectDocWorkflowApproverService";
import { ProjectStatusService } from "../pages/projects/services/ProjectStatusService";
import { UserService } from "../pages/settings/users/services/UserService";
import { UserTaskService } from "../pages/tasks/services/UserTaskService";
import { WorkflowService } from "../pages/workflows/services/WorkflowService";
import { WorkflowInstanceService } from "../pages/workflows/services/WorkflowInstanceService";
import { PDFNoteCommentService } from "../pages/notes/services/PDFNoteCommentService";
import { ProjectDocFolderCUserService } from "../pages/projectDocs/services/ProjectDocFolderCUserService";
import { StandartSolutionService } from "../pages/standartSolutions/services/StandartSolutionService";
import { PDFNoteWorkflowInstanceService } from "../pages/notes/services/PDFNoteWorkflowInstanceService";
import { ActTemplatesService } from "../pages/projectDocs/services/ActTemplateService";
import { StandartSolutionFolderService } from "../pages/standartSolutions/services/StandartSolutionFolderService";
import { ProjectDocSignerService, ProjectDocSignerRoleService } from "../pages/projectDocs/models/ProjectDocSignerQuery";
import { ActTemplateVariablesService } from "./ActTemplateVariablesService";
import { PaperSigningService } from "../pages/projectDocs/services/PaperSigningService";
import { HistoryEventService } from "../pages/history/services/HistoryEventService";

export interface ServicesState {
  history: History;
  userService: UserService;
  dictionariesService: DictionariesService;
  documentTypeService: DocTypeService;
  documentTemplateService: DocTemplateService;
  documentTemplateFolderService: DocTemplateFolderService;
  documentTemplateFolderTypeService: DocTemplateFolderTypeService;
  groupService: GroupService;
  groupTypeService: GroupTypeService;
  projectService: ProjectService;
  projectStatusService: ProjectStatusService;
  projectDocFolderService: ProjectDocFolderService;
  projectDocFolderCUserService: ProjectDocFolderCUserService;
  projectDocService: ProjectDocService;
  actTemplateService: ActTemplatesService;
  actTemplateVariablesService: ActTemplateVariablesService;
  workflowService:WorkflowService;
  workflowInstanceService:WorkflowInstanceService;
  projectDocWorkflowApproverService: ProjectDocWorkflowApproverService;
  projectDocFolderStatusService:ProjectDocFolderStatusService;
  userTaskService: UserTaskService;
  pDFNoteService: PDFNoteService;
  pDFNoteCodeService: PDFNoteCodeService;
  pDFNoteCommentService: PDFNoteCommentService;
  contractorsService: ContractorsService;
  balanceUnitService:BalanceUnitService;
  attachmentsService: AttachmentsService;
  authService: AuthService;
  pDFAttachmentsService: PDFAttachmentsService;
  pDFAttachmentsJsonService: PDFAttachmentsJsonService;
  standartSolutionService: StandartSolutionService;
  standartSolutionFolderService: StandartSolutionFolderService;
  pDFNoteWorkflowInstanceService: PDFNoteWorkflowInstanceService;
  projectDocSignerService: ProjectDocSignerService;
  projectDocSignerRoleService: ProjectDocSignerRoleService;
  paperSigningService: PaperSigningService;
  historyEventService: HistoryEventService;
}

let stateCache: ServicesState;

export let services!: ServicesState;

export function connectServices(history: History) {
  if (stateCache) {
    services = stateCache;
    return stateCache;
  }
  const dictionariesService = new DictionariesService(API);
  const documentTypeService = new DocTypeService(API);
  const documentTemplateService = new DocTemplateService(API);
  const documentTemplateFolderService = new DocTemplateFolderService(API);
  const userService = new UserService(API);
  const groupService = new GroupService(API);
  const projectService = new ProjectService(API);
  const projectStatusService = new ProjectStatusService(API);
  const groupTypeService = new GroupTypeService(API);
  const projectDocFolderService = new ProjectDocFolderService(API);
  const projectDocFolderCUserService = new ProjectDocFolderCUserService(API);
  const projectDocService = new ProjectDocService(API);
  const actTemplateService = new ActTemplatesService(API);
  const actTemplateVariablesService = new ActTemplateVariablesService(API);
  const documentTemplateFolderTypeService = new DocTemplateFolderTypeService(API);
  const projectDocWorkflowApproverService = new ProjectDocWorkflowApproverService(API);
  const workflowService = new WorkflowService(API);
  const workflowInstanceService = new WorkflowInstanceService(API);
  const projectDocFolderStatusService = new ProjectDocFolderStatusService(API);
  const userTaskService = new UserTaskService(API);
  const pDFNoteService = new PDFNoteService(API);
  const pDFNoteCodeService = new PDFNoteCodeService(API);
  const pDFNoteCommentService = new PDFNoteCommentService(API);
  const contractorsService = new ContractorsService(API);
  const balanceUnitService = new BalanceUnitService(API);
  const attachmentsService = new AttachmentsService(API);
  const authService = new AuthService(API);
  const pDFAttachmentsService = new PDFAttachmentsService(FormDataAPI);
  const pDFAttachmentsJsonService = new PDFAttachmentsJsonService(API);
  const standartSolutionService = new StandartSolutionService(FormDataAPI);
  const standartSolutionFolderService = new StandartSolutionFolderService(FormDataAPI);
  const pDFNoteWorkflowInstanceService = new PDFNoteWorkflowInstanceService(FormDataAPI);
  const projectDocSignerService = new ProjectDocSignerService(API);
  const projectDocSignerRoleService = new ProjectDocSignerRoleService(API);
  const paperSigningService = new PaperSigningService(API);
  const historyEventService = new HistoryEventService(API);

  return (services = stateCache = {
    history,
    dictionariesService,
    documentTypeService,
    documentTemplateService,
    userService,
    groupService,
    documentTemplateFolderService,
    projectService,
    projectStatusService,
    groupTypeService,
    projectDocFolderService,
    projectDocFolderCUserService,
    projectDocService,
    actTemplateService,
    actTemplateVariablesService,
    documentTemplateFolderTypeService,
    projectDocWorkflowApproverService,
    workflowService,
    projectDocFolderStatusService,
    workflowInstanceService,
    userTaskService,
    pDFNoteService,
    pDFNoteCodeService,
    pDFNoteCommentService,
    contractorsService,
    balanceUnitService,
    attachmentsService,
    authService,
    pDFAttachmentsService,
    pDFAttachmentsJsonService,
    standartSolutionService,
    standartSolutionFolderService,
    pDFNoteWorkflowInstanceService,
    projectDocSignerService,
    projectDocSignerRoleService,
    paperSigningService,
    historyEventService
  });
}
